(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WokCharts", [], factory);
	else if(typeof exports === 'object')
		exports["WokCharts"] = factory();
	else
		root["WokCharts"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("vue-property-decorator");

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = scaleToViewBox;
/* harmony export (immutable) */ __webpack_exports__["d"] = scaleValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = safeMax;
/* harmony export (immutable) */ __webpack_exports__["b"] = safeMin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__matrix__ = __webpack_require__(9);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};

function scaleToViewBox(points, width, height, xMargin, vMin, vMax) {
    if (xMargin === void 0) { xMargin = 0; }
    var xs = points.map(function (p) { return p[0]; });
    var ys = points.map(function (p) { return p[1]; });
    var xMin = Math.min.apply(Math, __spread(xs)) - xMargin;
    var xMax = Math.max.apply(Math, __spread(xs)) + xMargin;
    var yMin = Math.min.apply(Math, __spread(ys));
    var yMax = Math.max.apply(Math, __spread(ys));
    if (vMin != undefined) {
        yMin = Math.min(yMin, vMin);
    }
    if (vMax != undefined) {
        yMax = Math.max(yMax, vMax);
    }
    if (yMin == yMax) {
        if (yMax == 0) {
            yMax = 1;
        }
        else if (yMax > 0) {
            yMin = 0;
        }
        else {
            yMax = 0;
        }
    }
    var sx = xMax > xMin ? width / (xMax - xMin) : 1;
    var sy = yMax > yMin ? height / (yMax - yMin) : 1;
    var matrix = new __WEBPACK_IMPORTED_MODULE_0__matrix__["a" /* MatrixBuilder3 */]()
        .translate(-xMin, -yMin)
        .scale(sx, -sy)
        .translate(0, height)
        .build();
    return points.map(function (p) {
        if (p[1] === null) {
            p = Object(__WEBPACK_IMPORTED_MODULE_0__matrix__["b" /* multiplyVectorMatrix */])([p[0], 0], matrix);
            return [p[0], null];
        }
        else {
            return Object(__WEBPACK_IMPORTED_MODULE_0__matrix__["b" /* multiplyVectorMatrix */])(p, matrix).splice(0, 2);
        }
    });
}
function scaleValue(value, min, max, l) {
    if (l === void 0) { l = 1; }
    return (value - min) / (max - min) * l;
}
function safeMax() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var v = -Infinity;
    try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
            var a = args_1_1.value;
            if (Array.isArray(a)) {
                v = a.reduce(function (m, x) { return x != null && x > m ? x : m; }, v);
            }
            else if (typeof a == 'number' && a > v) {
                v = a;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (args_1_1 && !args_1_1.done && (_a = args_1.return)) _a.call(args_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return v;
    var e_1, _a;
}
function safeMin() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var v = Infinity;
    try {
        for (var args_2 = __values(args), args_2_1 = args_2.next(); !args_2_1.done; args_2_1 = args_2.next()) {
            var a = args_2_1.value;
            if (Array.isArray(a)) {
                v = a.reduce(function (m, x) { return x != null && x < m ? x : m; }, v);
            }
            else if (typeof a == 'number' && a < v) {
                v = a;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (args_2_1 && !args_2_1.done && (_a = args_2.return)) _a.call(args_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return v;
    var e_2, _a;
}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = currency;
/* harmony export (immutable) */ __webpack_exports__["c"] = pixel;
/* unused harmony export percent */
/* harmony export (immutable) */ __webpack_exports__["b"] = human;
function currency(value) {
    var precision = 2;
    var symbol = "€ ";
    var thousand = ".";
    var decimal = ",";
    var v = value ? value : 0;
    var sign = v < 0 ? "-" : "";
    var i = parseInt(Math.abs(v.toFixed(precision)) + "", 10) + "";
    var j = i.length > 3 ? i.length % 3 : 0;
    return symbol + sign + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) + (precision ? decimal + Math.abs(v - parseInt(sign + i)).toFixed(precision).slice(precision) : "");
}
function pixel(value) {
    return value ? value.toFixed(0) : 0;
}
function percent(value) {
    var precision = 2;
    var symbol = "%";
    var decimal = ",";
    var v = value ? value.toFixed(precision) : 0.00;
    return (v + "").replace('.', decimal) + symbol;
}
function human(value) {
    if (value >= 1000000) {
        return Math.round(value / 1000000) + 'M';
    }
    else if (value >= 1000) {
        return Math.round(value / 1000) + 'k';
    }
    else {
        return value;
    }
}


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(6);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bar_chart_bar_chart_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bar_chart_double_bar_chart_double_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bar_chart_horizontal_bar_chart_horizontal_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bullet_graph_bullet_graph_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mini_bar_mini_bar_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spark_line_spark_line_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__radar_chart_radar_chart_vue__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vertical_line_chart_vertical_line_chart_vue__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__scatter_plot_scatter_plot_vue__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChart", function() { return __WEBPACK_IMPORTED_MODULE_0__bar_chart_bar_chart_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChartDouble", function() { return __WEBPACK_IMPORTED_MODULE_1__bar_chart_double_bar_chart_double_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BarChartHorizontal", function() { return __WEBPACK_IMPORTED_MODULE_2__bar_chart_horizontal_bar_chart_horizontal_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BulletGraph", function() { return __WEBPACK_IMPORTED_MODULE_3__bullet_graph_bullet_graph_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MiniBar", function() { return __WEBPACK_IMPORTED_MODULE_4__mini_bar_mini_bar_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SparkLine", function() { return __WEBPACK_IMPORTED_MODULE_5__spark_line_spark_line_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RadarChart", function() { return __WEBPACK_IMPORTED_MODULE_6__radar_chart_radar_chart_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalLineChart", function() { return __WEBPACK_IMPORTED_MODULE_7__vertical_line_chart_vertical_line_chart_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScatterPlot", function() { return __WEBPACK_IMPORTED_MODULE_8__scatter_plot_scatter_plot_vue__["a"]; });
// Import, then re-export all default WokCharts widgets.









// WokCharts Vue plugin, to automatically register all components.
/* harmony default export */ __webpack_exports__["default"] = ({
    install: function (V, options) {
        V.component("bar-chart", __WEBPACK_IMPORTED_MODULE_0__bar_chart_bar_chart_vue__["a" /* default */]);
        V.component("bar-chart-double", __WEBPACK_IMPORTED_MODULE_1__bar_chart_double_bar_chart_double_vue__["a" /* default */]);
        V.component("bar-chart-horizontal", __WEBPACK_IMPORTED_MODULE_2__bar_chart_horizontal_bar_chart_horizontal_vue__["a" /* default */]);
        V.component("bullet-graph", __WEBPACK_IMPORTED_MODULE_3__bullet_graph_bullet_graph_vue__["a" /* default */]);
        V.component("mini-bar", __WEBPACK_IMPORTED_MODULE_4__mini_bar_mini_bar_vue__["a" /* default */]);
        V.component("spark-line", __WEBPACK_IMPORTED_MODULE_5__spark_line_spark_line_vue__["a" /* default */]);
        V.component("radar-chart", __WEBPACK_IMPORTED_MODULE_6__radar_chart_radar_chart_vue__["a" /* default */]);
        V.component("vertical-line-chart", __WEBPACK_IMPORTED_MODULE_7__vertical_line_chart_vertical_line_chart_vue__["a" /* default */]);
        V.component("scatter-plot", __WEBPACK_IMPORTED_MODULE_8__scatter_plot_scatter_plot_vue__["a" /* default */]);
    }
});
// Also export all components.



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_vue__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28de6830_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_vue__ = __webpack_require__(10);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28de6830_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bar-chart/bar-chart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-28de6830", Component.options)
  } else {
    hotAPI.reload("data-v-28de6830", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_filters__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var BarChart = /** @class */ (function (_super) {
    __extends(BarChart, _super);
    function BarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BarChart.prototype, "vMax", {
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["a" /* safeMax */])(this.values, this.target, this.targetGlobal);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "scaleTop", {
        get: function () {
            if (this.scales) {
                return this.scales.slice(-1)[0];
            }
            if (this.autoScalesMax > 0) {
                return this.autoScalesMax;
            }
            var top = Math.ceil(this.vMax + (this.topSpace * this.vMax / this.chartHeight));
            if (this.autoScales > 0) {
                return top - (top % (this.autoScales - 1)) + this.autoScales - 1;
            }
            return top;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "viewBox", {
        get: function () {
            var w = this.responsiveWidth;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "barThickness", {
        get: function () {
            var gaps = this.values.length * this.barGaps;
            var t = (this.chartWidth - gaps) / this.values.length;
            return t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "chartHeight", {
        get: function () {
            return this.height - 70;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "chartWidth", {
        get: function () {
            return this.responsiveWidth - 60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "points", {
        get: function () {
            var points = this.values.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "targets", {
        get: function () {
            if (this.target && this.target.length > 0) {
                var targets = this.target.map(function (y, x) { return [x, y]; });
                return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(targets, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChart.prototype, "scalesPoints", {
        get: function () {
            if (this.scales && this.scales.length > 0) {
                var l = this.scales.length;
                var points = [];
                for (var i = 0; i < l; i++) {
                    points.push([this.scales[i], (l - i) * (this.chartHeight / (l - 1)) - (this.chartHeight / (l - 1))]);
                }
                return points;
            }
            if (this.autoScales > 0) {
                var l = this.autoScales - 1, max = this.scaleTop;
                var points = [];
                for (var i = 0; i <= l; i++) {
                    var v = this.scaleTop / l * i;
                    points.push([v, (1 - (v / max)) * this.chartHeight]);
                }
                return points;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "labels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "target", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "targetGlobal", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChart.prototype, "scales", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "autoScales", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "autoScalesMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], BarChart.prototype, "valueLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: true })
    ], BarChart.prototype, "xSeparators", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], BarChart.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChart.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "padding", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChart.prototype, "topSpace", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 12 })
    ], BarChart.prototype, "barGaps", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], BarChart.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChart.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], BarChart.prototype, "targetColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(255,35,65)' })
    ], BarChart.prototype, "targetGlobalColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChart.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(213,218,223)' })
    ], BarChart.prototype, "xSeparatorsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(213,218,223)' })
    ], BarChart.prototype, "ySeparatorsColor", void 0);
    BarChart = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ filters: { currency: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["a" /* currency */], pixel: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["c" /* pixel */], human: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["b" /* human */] } })
    ], BarChart);
    return BarChart;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (BarChart);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Identity3D */
/* harmony export (immutable) */ __webpack_exports__["b"] = multiplyVectorMatrix;
/* unused harmony export multiplyMatrixMatrix */
/* unused harmony export multiplyMatrices */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MatrixBuilder3; });
var Identity3D = [1, 0, 0, 0, 1, 0, 0, 0, 1];
function multiplyVectorMatrix(v, m) {
    var x = v[0], y = v[1], z = v[2] || 1;
    return [
        x * m[0] + y * m[3] + z * m[6],
        x * m[1] + y * m[4] + z * m[7],
        x * m[2] + y * m[5] + z * m[8]
    ];
}
function multiplyMatrixMatrix(m, n) {
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], m4 = m[4], m5 = m[5], m6 = m[6], m7 = m[7], m8 = m[8];
    var n0 = n[0], n1 = n[1], n2 = n[2], n3 = n[3], n4 = n[4], n5 = n[5], n6 = n[6], n7 = n[7], n8 = n[8];
    return [
        m0 * n0 + m1 * n3 + m2 * n6,
        m0 * n1 + m1 * n4 + m2 * n7,
        m0 * n2 + m1 * n5 + m2 * n8,
        m3 * n0 + m4 * n3 + m5 * n6,
        m3 * n1 + m4 * n4 + m5 * n7,
        m3 * n2 + m4 * n5 + m5 * n8,
        m6 * n0 + m7 * n3 + m8 * n6,
        m6 * n1 + m7 * n4 + m8 * n7,
        m6 * n2 + m7 * n5 + m8 * n8
    ];
}
function multiplyMatrices(ms) {
    if (!ms) {
        throw Error("ms: argument can't be null");
    }
    if (ms.length > 0) {
        var m = ms[0];
        for (var i = 1; i < ms.length; i++) {
            m = multiplyMatrixMatrix(m, ms[i]);
        }
        return m;
    }
    return Identity3D;
}
var MatrixBuilder3 = /** @class */ (function () {
    function MatrixBuilder3(m) {
        if (m === void 0) { m = Identity3D; }
        this.m = m;
    }
    MatrixBuilder3.prototype.scale = function (x, y) {
        this.m = multiplyMatrixMatrix(this.m, [
            x, 0, 0,
            0, y, 0,
            0, 0, 1
        ]);
        return this;
    };
    MatrixBuilder3.prototype.rotate = function (a) {
        this.m = multiplyMatrixMatrix(this.m, [
            Math.cos(a), Math.sin(a), 0,
            -Math.sin(a), Math.cos(a), 0,
            0, 0, 1
        ]);
        return this;
    };
    MatrixBuilder3.prototype.translate = function (x, y) {
        this.m = multiplyMatrixMatrix(this.m, [
            1, 0, 0,
            0, 1, 0,
            x, y, 1
        ]);
        return this;
    };
    MatrixBuilder3.prototype.build = function () {
        return this.m;
    };
    return MatrixBuilder3;
}());



/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "bar-chart",
      style:
        "padding: " +
        _vm.padding +
        "px;" +
        " background-color: " +
        _vm.bgColor +
        ";"
    },
    [
      _c("svg", { attrs: { version: "1.1", viewBox: _vm.viewBox } }, [
        _c(
          "g",
          { staticClass: "graph", attrs: { transform: "translate(40, 30)" } },
          [
            _vm._l(_vm.points, function(p, i) {
              return i > 0 && _vm.xSeparators
                ? _c("g", { key: p + i, staticClass: "x-separators" }, [
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y1: "0",
                        x2: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: _vm.chartWidth - 0.5,
                        y1: "0",
                        x2: _vm.chartWidth - 0.5,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    })
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(_vm.scalesPoints, function(s, i) {
              return i != 0
                ? _c("g", { key: s + i, staticClass: "y-separators" }, [
                    _c("line", {
                      attrs: {
                        stroke: _vm.ySeparatorsColor,
                        "stroke-width": "1",
                        "stroke-linecap": "round",
                        "stroke-dasharray": _vm.xSeparators ? (0.5, 3) : null,
                        x1: "0",
                        y1: s[1] - 0.5,
                        x2: _vm.chartWidth,
                        y2: s[1] - 0.5
                      }
                    })
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(_vm.points, function(k, i) {
              return _c("g", { key: k + i, staticClass: "column" }, [
                _vm.points[i] !== null
                  ? _c("rect", {
                      staticClass: "bar",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.barColor,
                        x: _vm.points[i][0] - _vm.barThickness / 2,
                        y: _vm.points[i][1],
                        width: _vm.barThickness,
                        height: _vm.chartHeight - _vm.points[i][1]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.target && _vm.target.length > 0
                  ? _c("rect", {
                      staticClass: "target",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.targetColor,
                        x: _vm.targets[i][0] - _vm.barThickness / 2 - 3,
                        y: _vm._f("pixel")(_vm.targets[i][1]),
                        width: _vm.barThickness + 6,
                        height: "1",
                        "shape-rendering": "crispEdges"
                      }
                    })
                  : _vm._e()
              ])
            }),
            _vm._v(" "),
            _vm.targetGlobal != null
              ? _c("line", {
                  staticClass: "target-global",
                  attrs: {
                    "stroke-width": "2",
                    stroke: _vm.targetGlobalColor,
                    x1: "0",
                    y1:
                      (1 - _vm.targetGlobal / _vm.scaleTop) * _vm.chartHeight -
                      0.5,
                    x2: _vm.chartWidth,
                    y2:
                      (1 - _vm.targetGlobal / _vm.scaleTop) * _vm.chartHeight -
                      0.5,
                    "shape-rendering": "crispEdges"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.valueLabels
              ? _c(
                  "g",
                  { staticClass: "value-labels" },
                  _vm._l(_vm.points, function(k, i) {
                    return _vm.values[i] > 0
                      ? _c(
                          "text",
                          {
                            key: k + i,
                            staticClass: "value-label",
                            staticStyle: {
                              "font-size": "12px",
                              "font-family": "'Fira Sans'",
                              "font-weight": "500"
                            },
                            attrs: {
                              fill: _vm.barColor,
                              transform:
                                "rotate(-60," +
                                _vm.points[i][0] +
                                "," +
                                (_vm.points[i][1] - 3) +
                                ")",
                              x: _vm.points[i][0],
                              y: _vm.points[i][1] - 3
                            }
                          },
                          [_vm._v(_vm._s(_vm.values[i]))]
                        )
                      : _vm._e()
                  })
                )
              : _vm._e(),
            _vm._v(" "),
            _c("line", {
              staticClass: "y-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: "0",
                x2: "0",
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "x-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: _vm.chartHeight + 0.5,
                x2: _vm.chartWidth,
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "x-labels" },
              _vm._l(_vm.labels, function(l, i) {
                return _c(
                  "text",
                  {
                    key: l + i,
                    staticStyle: {
                      "font-size": "13px",
                      "text-transform": "lowercase",
                      "font-variant": "small-caps",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "middle",
                      x:
                        i * (_vm.chartWidth / _vm.labels.length) +
                        _vm.chartWidth / (_vm.labels.length * 2),
                      y: _vm.chartHeight + 20
                    }
                  },
                  [_vm._v(_vm._s(l))]
                )
              })
            ),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "y-labels" },
              _vm._l(_vm.scalesPoints, function(s, i) {
                return _c(
                  "text",
                  {
                    key: s + i,
                    staticStyle: {
                      "font-size": "12px",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "end",
                      x: "-8",
                      y: s[1] + 3
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("human")(s[0])))]
                )
              })
            )
          ],
          2
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-28de6830", esExports)
  }
}

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_double_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9e81d34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_double_vue__ = __webpack_require__(13);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_double_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9e81d34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_double_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bar-chart-double/bar-chart-double.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e9e81d34", Component.options)
  } else {
    hotAPI.reload("data-v-e9e81d34", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_filters__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};




var BarChartDouble = /** @class */ (function (_super) {
    __extends(BarChartDouble, _super);
    function BarChartDouble() {
        // Props definitions.
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Reactive data
        _this.stepLastEvent = null;
        _this.stepValue = null;
        _this.stepTarget = null;
        _this.isLeftCol = false;
        _this.scales = [1000, 10000, 50000, 100000, 200000, 300000, 500000, 1000000];
        return _this;
    }
    Object.defineProperty(BarChartDouble.prototype, "vMax", {
        get: function () {
            var values1 = this.values1.filter(function (x) { return x != null; });
            var values2 = this.values2.filter(function (x) { return x != null; });
            var target2 = this.target2.filter(function (x) { return x != null; });
            return Math.max.apply(Math, __spread(values1, values2, target2));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "scaleTop", {
        get: function () {
            var s = this.scales[0];
            for (var i = 1; i < this.scales.length; i++) {
                if (s >= this.vMax) {
                    return s;
                }
                ;
                s = this.scales[i];
            }
            return s;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "barThickness", {
        get: function () {
            var gaps = this.values1.length * this.barGaps;
            var t = (this.chartWidth - gaps) / this.values1.length;
            return t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "chartHeight", {
        get: function () {
            return this.height - 70;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "chartWidth", {
        get: function () {
            return this.width - 60;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "points1", {
        get: function () {
            var vs = this.values1;
            var points = vs.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "points2", {
        get: function () {
            var vs = this.values2;
            var points = vs.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartDouble.prototype, "targets2", {
        get: function () {
            var vs = this.target2;
            var targets = vs.map(function (y, x) { return [x, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(targets, this.chartWidth, this.chartHeight, 0.5, 0, this.scaleTop);
        },
        enumerable: true,
        configurable: true
    });
    // Methods
    BarChartDouble.prototype.updated = function () {
        if (this.stepLastEvent && this.stepLastEvent.target instanceof SVGElement) {
            var label = document.querySelector(".step-label");
            var yPos = this.stepLastEvent.target.getAttribute("y");
            var xPos = this.stepLastEvent.target.getAttribute("x");
            var height = this.stepLastEvent.target.getAttribute("height");
            var width = this.stepLastEvent.target.getAttribute("width");
            this.stepValue = parseFloat(this.stepLastEvent.target.getAttribute("data-value"));
            this.stepTarget = parseFloat(this.stepLastEvent.target.getAttribute("data-target"));
            label.style.left = parseInt(xPos) + parseInt(width) + 59 + 'px';
            label.style.top = parseInt(yPos) + (parseInt(height) / 2) + 43 + 'px';
            label.style.transform = 'translateY(-50%)';
        }
    };
    BarChartDouble.prototype.onStepOver = function (evt) {
        if (evt.target instanceof SVGElement && this.stepLastEvent === null) {
            this.stepLastEvent = evt;
        }
    };
    BarChartDouble.prototype.onStepOut = function (evt) {
        if (evt.target instanceof SVGElement) {
            this.stepLastEvent = null;
        }
    };
    BarChartDouble.prototype.onLeftColOver = function (evt) {
        if (evt.target instanceof SVGElement && this.stepLastEvent === null) {
            this.stepLastEvent = evt;
            this.isLeftCol = true;
        }
    };
    BarChartDouble.prototype.onLeftColOut = function (evt) {
        if (evt.target instanceof SVGElement) {
            this.stepLastEvent = null;
            this.isLeftCol = false;
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], BarChartDouble.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartDouble.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChartDouble.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], BarChartDouble.prototype, "barColorTwo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], BarChartDouble.prototype, "targetColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 12 })
    ], BarChartDouble.prototype, "barGaps", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BarChartDouble.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(200,200,200)' })
    ], BarChartDouble.prototype, "xSeparatorsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(200,200,200)' })
    ], BarChartDouble.prototype, "ySeparatorsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], BarChartDouble.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "icon", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "labels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "values1", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "values2", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BarChartDouble.prototype, "target2", void 0);
    BarChartDouble = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ filters: { currency: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["a" /* currency */], pixel: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["c" /* pixel */], human: __WEBPACK_IMPORTED_MODULE_3__utils_filters__["b" /* human */] } })
    ], BarChartDouble);
    return BarChartDouble;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (BarChartDouble);


/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bar-chart-double" }, [
    _c(
      "svg",
      {
        style: "padding:2px;background-color:" + _vm.bgColor + ";",
        attrs: { version: "1.1", viewBox: _vm.viewBox }
      },
      [
        _c(
          "g",
          { staticClass: "graph", attrs: { transform: "translate(40, 40)" } },
          [
            _vm._l(_vm.points1, function(p, i) {
              return i > 0
                ? _c("g", { key: i, staticClass: "x-separators" }, [
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y1: "0",
                        x2: p[0] - _vm.barThickness / 2 - _vm.barGaps / 2,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    }),
                    _vm._v(" "),
                    _c("line", {
                      attrs: {
                        stroke: _vm.xSeparatorsColor,
                        "stroke-width": "1",
                        x1: _vm.chartWidth - 0.5,
                        y1: "0",
                        x2: _vm.chartWidth - 0.5,
                        y2: _vm.chartHeight,
                        "shape-rendering": "crispEdges"
                      }
                    })
                  ])
                : _vm._e()
            }),
            _vm._v(" "),
            _vm._l(10, function(j) {
              return _c("g", { key: j, staticClass: "y-separators" }, [
                _c("line", {
                  attrs: {
                    stroke: _vm.ySeparatorsColor,
                    "stroke-width": "1",
                    "stroke-linecap": "round",
                    "stroke-dasharray": "0.5, 3",
                    x1: "0",
                    y1: j * (_vm.chartHeight / 10) - _vm.chartHeight / 10 - 0.5,
                    x2: _vm.chartWidth,
                    y2: j * (_vm.chartHeight / 10) - _vm.chartHeight / 10 - 0.5
                  }
                })
              ])
            }),
            _vm._v(" "),
            _vm._l(_vm.points1.length, function(k, i) {
              return _c("g", { key: i, staticClass: "column-left" }, [
                _vm.points1[i] !== null
                  ? _c("rect", {
                      staticClass: "bar",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.barColor,
                        x: _vm.points1[i][0] - _vm.barThickness / 2,
                        y: _vm.points1[i][1],
                        width: _vm.barThickness / 3,
                        height: _vm.chartHeight - _vm.points1[i][1]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-bg",
                  attrs: {
                    fill: _vm.barColorTwo,
                    x: _vm.points1[i][0] - _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-event",
                  staticStyle: { cursor: "pointer" },
                  attrs: {
                    fill: "transparent",
                    x: _vm.points1[i][0] - _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight,
                    "data-value": _vm.values1[i]
                  },
                  on: {
                    mouseover: _vm.onLeftColOver,
                    mouseout: _vm.onLeftColOut
                  }
                })
              ])
            }),
            _vm._v(" "),
            _vm._l(_vm.points2.length, function(k, i) {
              return _c("g", { key: i, staticClass: "column-right" }, [
                _vm.points2[i] !== null
                  ? _c("rect", {
                      staticClass: "bar",
                      staticStyle: { transition: "all 0.3s" },
                      attrs: {
                        fill: _vm.barColorTwo,
                        x:
                          _vm.points2[i][0] -
                          _vm.barThickness / 6 +
                          _vm.barThickness / 3,
                        y: _vm.points2[i][1],
                        width: _vm.barThickness / 3,
                        height: _vm.chartHeight - _vm.points2[i][1]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "target",
                  staticStyle: { transition: "all 0.3s" },
                  attrs: {
                    fill: _vm.targetColor,
                    x:
                      _vm.targets2[i][0] -
                      _vm.barThickness / 6 +
                      _vm.barThickness / 3 -
                      3,
                    y: _vm._f("pixel")(_vm.targets2[i][1]),
                    width: _vm.barThickness / 3 + 6,
                    height: "1",
                    "shape-rendering": "crispEdges"
                  }
                }),
                _vm._v(" "),
                (_vm.points2[i][1] !== _vm.chartHeight) |
                (_vm.targets2[i][1] !== _vm.chartHeight)
                  ? _c("g", { staticClass: "difference" }, [
                      _c("line", {
                        attrs: {
                          stroke: _vm.targetColor,
                          "stroke-width": "1",
                          x1: _vm.points2[i][0] + _vm.barThickness / 3,
                          y1: _vm.targets2[i][1],
                          x2: _vm.points2[i][0] + _vm.barThickness / 3,
                          y2: _vm.points2[i][1]
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          staticClass: "arrow-top",
                          attrs: {
                            transform:
                              "translate(" +
                              (_vm.points2[i][0] + _vm.barThickness / 3) +
                              "," +
                              _vm.targets2[i][1] +
                              ")"
                          }
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              points: "-3,4 0,0 3,4",
                              fill: _vm.targetColor
                            }
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          staticClass: "arrow-bottom",
                          attrs: {
                            transform:
                              "translate(" +
                              (_vm.points2[i][0] + _vm.barThickness / 3) +
                              "," +
                              _vm.points2[i][1] +
                              ")"
                          }
                        },
                        [
                          _c("polygon", {
                            attrs: {
                              points: "-3,-4 0,0 3,-4",
                              fill: _vm.targetColor
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-bg",
                  attrs: {
                    fill: _vm.barColor,
                    x: _vm.points2[i][0] + _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight
                  }
                }),
                _vm._v(" "),
                _c("rect", {
                  staticClass: "col-event",
                  staticStyle: { cursor: "pointer" },
                  attrs: {
                    fill: "transparent",
                    x: _vm.points2[i][0] + _vm.barThickness / 3 - _vm.barGaps,
                    y: "0",
                    width: _vm.barThickness / 3 + _vm.barGaps,
                    height: _vm.chartHeight,
                    "data-value": _vm.values2[i],
                    "data-target": _vm.target2[i]
                  },
                  on: { mouseover: _vm.onStepOver, mouseout: _vm.onStepOut }
                })
              ])
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "y-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: "-10",
                x2: "0",
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c("line", {
              staticClass: "x-axis",
              attrs: {
                "stroke-width": "1",
                stroke: _vm.axisColor,
                x1: "0",
                y1: _vm.chartHeight + 0.5,
                x2: _vm.chartWidth,
                y2: _vm.chartHeight + 0.5,
                "shape-rendering": "crispEdges"
              }
            }),
            _vm._v(" "),
            _c("circle", {
              staticClass: "chart-icon-bg",
              attrs: { cx: "0", cy: "-20", r: "10", fill: _vm.axisColor }
            }),
            _vm._v(" "),
            _c("image", {
              attrs: {
                "xlink:href": _vm.icon,
                x: "-5.5",
                y: "-25.5",
                width: "10",
                height: "10"
              }
            }),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "x-labels" },
              _vm._l(_vm.labels, function(l, i) {
                return _c(
                  "text",
                  {
                    key: i,
                    staticStyle: {
                      "font-size": "13px",
                      "text-transform": "lowercase",
                      "font-variant": "small-caps",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "middle",
                      x:
                        i * (_vm.chartWidth / _vm.labels.length) +
                        _vm.chartWidth / (_vm.labels.length * 2),
                      y: _vm.chartHeight + 20
                    }
                  },
                  [_vm._v(_vm._s(l))]
                )
              })
            ),
            _vm._v(" "),
            _c(
              "g",
              { staticClass: "y-labels" },
              _vm._l(10, function(j) {
                return _c(
                  "text",
                  {
                    key: j,
                    staticStyle: {
                      "font-size": "12px",
                      "font-family": "'Fira Sans'",
                      "font-weight": "300"
                    },
                    attrs: {
                      fill: "black",
                      "text-anchor": "end",
                      x: "-8",
                      y: _vm.chartHeight - j * (_vm.chartHeight / 10) + 3
                    }
                  },
                  [_vm._v(_vm._s(_vm._f("human")(_vm.scaleTop / 10 * j)))]
                )
              })
            )
          ],
          2
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !!_vm.stepLastEvent,
            expression: "!!stepLastEvent"
          }
        ],
        staticClass: "step-label"
      },
      [
        _vm.isLeftCol
          ? _c(
              "div",
              {
                staticClass: "step-label-values",
                style: "color:" + _vm.barColor + ";"
              },
              [
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Fatturato:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.stepValue)))
                  ])
                ])
              ]
            )
          : _c(
              "div",
              {
                staticClass: "step-label-values",
                style: "color:" + _vm.barColor + ";"
              },
              [
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Consuntivato:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.stepValue)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Ordinato:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(_vm._s(_vm._f("currency")(_vm.stepTarget)))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "step-label-row" }, [
                  _c("div", { staticClass: "step-label-title" }, [
                    _vm._v("Differenza:")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "step-label-value" }, [
                    _vm._v(
                      _vm._s(_vm._f("currency")(_vm.stepValue - _vm.stepTarget))
                    )
                  ])
                ])
              ]
            )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e9e81d34", esExports)
  }
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_horizontal_vue__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a81c74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_horizontal_vue__ = __webpack_require__(16);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bar_chart_horizontal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_87a81c74_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bar_chart_horizontal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bar-chart-horizontal/bar-chart-horizontal.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-87a81c74", Component.options)
  } else {
    hotAPI.reload("data-v-87a81c74", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var BarChartHorizontal = /** @class */ (function (_super) {
    __extends(BarChartHorizontal, _super);
    function BarChartHorizontal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BarChartHorizontal.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartHorizontal.prototype, "height", {
        get: function () {
            return this.paddingTop + this.paddingBottom + (this.barThickness + this.barGaps) * this.points.length;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartHorizontal.prototype, "viewBox", {
        get: function () {
            var w = this.responsiveWidth;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BarChartHorizontal.prototype, "plotPoints", {
        get: function () {
            var _this = this;
            var ps = {};
            ps = (this.points.map(function (v, i) {
                var w = _this.responsiveWidth - _this.paddingLeft - _this.paddingRight;
                var hs = (_this.height - _this.paddingTop - _this.paddingBottom - (_this.barThickness)) / (_this.points.length - 1);
                return {
                    x: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v.value, _this.rangeMin, _this.rangeMax, w) + _this.paddingLeft,
                    y: (hs * i + _this.paddingTop)
                };
            }));
            return ps;
        },
        enumerable: true,
        configurable: true
    });
    BarChartHorizontal.prototype.barLabelsXPos = function (value) {
        if (value == 0) {
            return 0;
        }
        else if (value > 90) {
            return -8;
        }
        else {
            return 8;
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], BarChartHorizontal.prototype, "points", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 0 })
    ], BarChartHorizontal.prototype, "rangeMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 100 })
    ], BarChartHorizontal.prototype, "rangeMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 700 })
    ], BarChartHorizontal.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "paddingTop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "paddingRight", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "paddingBottom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 80 })
    ], BarChartHorizontal.prototype, "paddingLeft", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 30 })
    ], BarChartHorizontal.prototype, "barThickness", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], BarChartHorizontal.prototype, "barGaps", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], BarChartHorizontal.prototype, "showMarkers", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgba(0,0,0,0.05)' })
    ], BarChartHorizontal.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'coral' })
    ], BarChartHorizontal.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 16 })
    ], BarChartHorizontal.prototype, "pointsLabelsTextSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 30 })
    ], BarChartHorizontal.prototype, "pointsLabelsImageSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(100,100,100)' })
    ], BarChartHorizontal.prototype, "pointsLabelsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(50,50,50)' })
    ], BarChartHorizontal.prototype, "barLabelsColor", void 0);
    BarChartHorizontal = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], BarChartHorizontal);
    return BarChartHorizontal;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (BarChartHorizontal);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bar-chart-horizontal" }, [
    _c(
      "svg",
      {
        style: "background-color: " + _vm.bgColor + ";",
        attrs: {
          version: "1.1",
          width: _vm.responsiveWidth,
          height: _vm.height,
          viewBox: _vm.viewBox
        }
      },
      [
        _c(
          "g",
          { staticClass: "points" },
          _vm._l(_vm.plotPoints, function(p, index) {
            return _c("rect", {
              key: index + "_value",
              staticClass: "value_bar",
              attrs: {
                fill: _vm.barColor,
                x: _vm.paddingLeft,
                y: p.y,
                stroke: _vm.barColor,
                width: p.x - _vm.paddingLeft,
                height: _vm.barThickness
              }
            })
          })
        ),
        _vm._v(" "),
        _vm._l(_vm.plotPoints, function(p, index) {
          return _c(
            "g",
            {
              key: index + "_value_label",
              staticClass: "labels",
              attrs: {
                transform: "translate(0, " + (p.y + _vm.barThickness / 2) + ")"
              }
            },
            [
              _c(
                "text",
                {
                  attrs: {
                    x: p.x,
                    y: "0",
                    dx: _vm.barLabelsXPos(_vm.points[index].value),
                    dy: "5",
                    "text-anchor":
                      _vm.points[index].value > 90 ? "end" : "start",
                    "font-size": _vm.pointsLabelsTextSize,
                    fill: _vm.barLabelsColor
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.points[index].value) +
                      "%\n            "
                  )
                ]
              ),
              _vm._v(" "),
              !_vm.showMarkers
                ? _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.paddingLeft - 24,
                        y: "0",
                        dy: "5",
                        "font-size": _vm.pointsLabelsTextSize,
                        "text-anchor": "end",
                        fill: _vm.pointsLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.points[index].label) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showMarkers
                ? _c("image", {
                    attrs: {
                      "xlink:href": _vm.points[index].markerUrl,
                      height: _vm.pointsLabelsImageSize,
                      width: _vm.pointsLabelsImageSize,
                      x: _vm.paddingLeft - _vm.pointsLabelsImageSize - 20,
                      y: -(_vm.pointsLabelsImageSize / 2)
                    }
                  })
                : _vm._e()
            ]
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87a81c74", esExports)
  }
}

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bullet_graph_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d83bd86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bullet_graph_vue__ = __webpack_require__(19);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_bullet_graph_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d83bd86_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_bullet_graph_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/bullet-graph/bullet-graph.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0d83bd86", Component.options)
  } else {
    hotAPI.reload("data-v-0d83bd86", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var BulletGraph = /** @class */ (function (_super) {
    __extends(BulletGraph, _super);
    function BulletGraph() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BulletGraph.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            if (this.showLabels) {
                h = this.height * 2;
            }
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], BulletGraph.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], BulletGraph.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(220,220,220)' })
    ], BulletGraph.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(80,80,80)' })
    ], BulletGraph.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], BulletGraph.prototype, "strokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], BulletGraph.prototype, "labelColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], BulletGraph.prototype, "showLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], BulletGraph.prototype, "values", void 0);
    BulletGraph = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], BulletGraph);
    return BulletGraph;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (BulletGraph);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bullet-graph", staticStyle: { "font-size": "0" } },
    [
      _c(
        "svg",
        {
          style: _vm.showLabels ? "padding: 2px 14px;" : "padding: 2px;",
          attrs: { version: "1.1", viewBox: _vm.viewBox }
        },
        [
          _c("rect", {
            staticClass: "bg",
            attrs: {
              fill: _vm.bgColor,
              x: "0",
              y: "0",
              width: _vm.width,
              height: _vm.height
            }
          }),
          _vm._v(" "),
          _c("rect", {
            staticClass: "bar",
            attrs: {
              fill: _vm.barColor,
              x: "0",
              y: _vm.height / 4,
              width: _vm.values[0],
              height: _vm.height / 2,
              "shape-rendering": "crispEdges"
            }
          }),
          _vm._v(" "),
          _c("line", {
            attrs: {
              x1: _vm.values[1] + 0.5,
              y1: "0",
              x2: _vm.values[1] + 0.5,
              y2: _vm.height,
              stroke: _vm.strokeColor,
              "stroke-width": "1"
            }
          }),
          _vm._v(" "),
          _vm.showLabels
            ? _c("g", { staticClass: "percentage-labels" }, [
                _c("g", { staticClass: "label-lines" }, [
                  _c("line", {
                    attrs: {
                      x1: "0.5",
                      y1: _vm.height,
                      x2: "0.5",
                      y2: _vm.height + 5,
                      stroke: _vm.labelColor,
                      "stroke-width": "1"
                    }
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: {
                      x1: _vm.width / 2 + 0.5,
                      y1: _vm.height,
                      x2: _vm.width / 2 + 0.5,
                      y2: _vm.height + 5,
                      stroke: _vm.labelColor,
                      "stroke-width": "1"
                    }
                  }),
                  _vm._v(" "),
                  _c("line", {
                    attrs: {
                      x1: _vm.width - 0.5,
                      y1: _vm.height,
                      x2: _vm.width - 0.5,
                      y2: _vm.height + 5,
                      stroke: _vm.labelColor,
                      "stroke-width": "1"
                    }
                  })
                ]),
                _vm._v(" "),
                _c("g", { staticClass: "label-texts" }, [
                  _c(
                    "text",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "font-family": "'Fira Sans'",
                        "font-weight": "300"
                      },
                      attrs: {
                        x: "0",
                        y: _vm.height,
                        dy: "16",
                        fill: _vm.labelColor,
                        "text-anchor": "middle"
                      }
                    },
                    [_vm._v("0%")]
                  ),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "font-family": "'Fira Sans'",
                        "font-weight": "300"
                      },
                      attrs: {
                        x: _vm.width / 2,
                        y: _vm.height,
                        dy: "16",
                        fill: _vm.labelColor,
                        "text-anchor": "middle"
                      }
                    },
                    [_vm._v("50%")]
                  ),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      staticStyle: {
                        "font-size": "10px",
                        "font-family": "'Fira Sans'",
                        "font-weight": "300"
                      },
                      attrs: {
                        x: _vm.width,
                        y: _vm.height,
                        dy: "16",
                        fill: _vm.labelColor,
                        "text-anchor": "middle"
                      }
                    },
                    [_vm._v("100%")]
                  )
                ])
              ])
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d83bd86", esExports)
  }
}

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_mini_bar_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21daf074_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_mini_bar_vue__ = __webpack_require__(22);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_mini_bar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21daf074_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_mini_bar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/mini-bar/mini-bar.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-21daf074", Component.options)
  } else {
    hotAPI.reload("data-v-21daf074", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var MiniBar = /** @class */ (function (_super) {
    __extends(MiniBar, _super);
    function MiniBar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MiniBar.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MiniBar.prototype, "barThickness", {
        get: function () {
            var gaps = 0;
            if (this.gaps) {
                gaps = this.values.length * 2;
            }
            var t = (this.width - gaps) / this.values.length;
            return t;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MiniBar.prototype, "points", {
        get: function () {
            var points = this.values.map(function (y, i) { return [i, y]; });
            return Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.width, this.height, 0.5, this.vMin, this.vMax);
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 100 })
    ], MiniBar.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], MiniBar.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'black' })
    ], MiniBar.prototype, "barColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(220,220,220)' })
    ], MiniBar.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], MiniBar.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], MiniBar.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], MiniBar.prototype, "vMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], MiniBar.prototype, "vMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: true })
    ], MiniBar.prototype, "gaps", void 0);
    MiniBar = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], MiniBar);
    return MiniBar;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (MiniBar);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "mini-bar", staticStyle: { "font-size": "0" } },
      [
        _c(
          "svg",
          {
            style: "padding:2px;background-color:" + _vm.bgColor + ";",
            attrs: { version: "1.1", viewBox: _vm.viewBox }
          },
          [
            _vm._l(_vm.points, function(p) {
              return p[1] != null && p[1] != _vm.height
                ? _c("rect", {
                    key: p[0],
                    attrs: {
                      x: p[0] - _vm.barThickness / 2,
                      y: p[1],
                      width: _vm.barThickness,
                      height: _vm.height - p[1],
                      fill: _vm.barColor
                    }
                  })
                : _vm._e()
            }),
            _vm._v(" "),
            _c("line", {
              attrs: {
                x1: "0",
                y1: _vm.height - 0.5,
                x2: _vm.width,
                y2: _vm.height - 0.5,
                "stroke-width": "1",
                stroke: _vm.axisColor
              }
            })
          ],
          2
        )
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21daf074", esExports)
  }
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_spark_line_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9ead34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_spark_line_vue__ = __webpack_require__(25);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_spark_line_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9ead34_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_spark_line_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/spark-line/spark-line.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6e9ead34", Component.options)
  } else {
    hotAPI.reload("data-v-6e9ead34", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var SparkLine = /** @class */ (function (_super) {
    __extends(SparkLine, _super);
    function SparkLine() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SparkLine.prototype, "viewBox", {
        // Generated properties
        get: function () {
            var w = this.width;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SparkLine.prototype, "pathD", {
        get: function () {
            var ps = this.transformValues();
            var d = "";
            var start = true;
            for (var i = 0; i < ps.length; i++) {
                if (ps[i][1] === null) {
                    start = true;
                }
                else {
                    if (start) {
                        d += " M " + ps[i][0] + " " + ps[i][1];
                        start = false;
                    }
                    else {
                        d += " L " + ps[i][0] + " " + ps[i][1];
                    }
                }
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    SparkLine.prototype.transformValues = function () {
        var vs = this.values;
        var points = vs.map(function (y, x) { return [x, y]; });
        return Object(__WEBPACK_IMPORTED_MODULE_2__utils_viewport_utils__["c" /* scaleToViewBox */])(points, this.width, this.height, 0, this.vMin, this.vMax);
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 100 })
    ], SparkLine.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 20 })
    ], SparkLine.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'black' })
    ], SparkLine.prototype, "strokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], SparkLine.prototype, "bgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], SparkLine.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], SparkLine.prototype, "vMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], SparkLine.prototype, "vMax", void 0);
    SparkLine = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], SparkLine);
    return SparkLine;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (SparkLine);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sparkline" }, [
    _c(
      "svg",
      {
        style: "padding:2px;background-color:" + _vm.bgColor + ";",
        attrs: { version: "1.1", viewBox: _vm.viewBox }
      },
      [
        _c("path", {
          attrs: {
            d: _vm.pathD,
            stroke: _vm.strokeColor,
            "stroke-width": "1",
            fill: "transparent"
          }
        })
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e9ead34", esExports)
  }
}

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_radar_chart_vue__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078c9d54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_radar_chart_vue__ = __webpack_require__(28);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_radar_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078c9d54_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_radar_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/radar-chart/radar-chart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-078c9d54", Component.options)
  } else {
    hotAPI.reload("data-v-078c9d54", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};


function valueToPoint(value, index, count, diameter, xoffset, yoffset) {
    if (xoffset === void 0) { xoffset = 0; }
    if (yoffset === void 0) { yoffset = 0; }
    var r = diameter / 2;
    var angle = ((Math.PI * 2) / count) * index - (Math.PI / 2);
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var tx = r + value * r * cos + xoffset;
    var ty = r + value * r * sin + yoffset;
    return [tx, ty];
}
function scaleValues(values, min, max) {
    if (min === void 0) { min = 0.1; }
    if (max === void 0) { max = 0.9; }
    var l = max - min;
    var pointsMax = __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["a" /* safeMax */].apply(void 0, __spread(values));
    return values.map(function (x) { return x.map(function (p) {
        var s = p / pointsMax;
        return l * s + min;
    }); });
}
var RadarChart = /** @class */ (function (_super) {
    __extends(RadarChart, _super);
    function RadarChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(RadarChart.prototype, "responsiveSize", {
        /*  @Watch('values')
         watchValues(newValue: number[][], oldValue: number[][]) {
             console.log("WATCH", oldValue);
         } */
        get: function () {
            var d = this.diameter;
            var s = d + (d / 6);
            var ms = window.innerWidth - 80;
            var md = ms * 6 / 7;
            if (s < ms) {
                return {
                    size: s,
                    diameter: d
                };
            }
            else {
                return {
                    size: ms,
                    diameter: md
                };
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "viewBox", {
        get: function () {
            return '0 0 ' + this.responsiveSize.size + ' ' + this.responsiveSize.size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "labels", {
        get: function () {
            return this.markersColors.map(function (l) { return ({ color: l }); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "valuesIndices", {
        get: function () {
            return Array.from(new Array(this.values.length), function (v, i) { return i; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "scaledValues", {
        get: function () {
            return scaleValues(this.values);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "labelPoints", {
        get: function () {
            var count = this.labels.length;
            var diameter = this.responsiveSize.diameter + (this.responsiveSize.diameter / 12);
            var offset = this.responsiveSize.diameter / 24;
            return this.labels.map(function (l, index) {
                var point = valueToPoint(1, index, count, diameter, offset, offset);
                return __assign({}, l, { x: point[0], y: point[1] });
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadarChart.prototype, "axisPoints", {
        get: function () {
            var count = this.labels.length;
            var diameter = this.responsiveSize.diameter;
            var offset = this.responsiveSize.diameter / 12;
            return this.labels.map(function (l, index) {
                var point = valueToPoint(1, index, count, diameter, offset, offset);
                return {
                    x: point[0],
                    y: point[1]
                };
            });
        },
        enumerable: true,
        configurable: true
    });
    RadarChart.prototype.points = function (index) {
        var count = this.scaledValues[index].length;
        var diameter = this.responsiveSize.diameter;
        var offset = this.responsiveSize.diameter / 12;
        return 'M' + this.scaledValues[index].map(function (v, i) {
            var point = valueToPoint(v, i, count, diameter, offset, offset);
            return point[0] + ' ' + point[1] + ',';
        }).join(' ');
    };
    RadarChart.prototype.pointsCaps = function (index) {
        var count = this.scaledValues[index].length;
        var diameter = this.responsiveSize.diameter;
        var offset = this.responsiveSize.diameter / 12;
        return this.scaledValues[index].map(function (v, i) {
            var point = valueToPoint(v, i, count, diameter, offset, offset);
            return {
                x: point[0],
                y: point[1]
            };
        });
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 250 })
    ], RadarChart.prototype, "diameter", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], RadarChart.prototype, "strokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "valuesLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "shapeColors", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], RadarChart.prototype, "markersColors", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(55,71,79' })
    ], RadarChart.prototype, "labelsColor", void 0);
    RadarChart = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], RadarChart);
    return RadarChart;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (RadarChart);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "radar-chart" }, [
    _c(
      "svg",
      {
        attrs: {
          version: "1.1",
          width: _vm.responsiveSize.size,
          height: _vm.responsiveSize.size,
          viewBox: _vm.viewBox
        }
      },
      [
        _vm._l(_vm.labelPoints, function(l, key) {
          return _c("circle", {
            key: key + "_marker",
            staticClass: "marker",
            attrs: {
              cx: l.x,
              cy: l.y,
              r: _vm.responsiveSize.diameter / 24,
              fill: l.color
            }
          })
        }),
        _vm._v(" "),
        _vm._l(_vm.axisPoints, function(p, key) {
          return _c("line", {
            key: key + "_axis",
            staticClass: "axis",
            attrs: {
              x1: p.x,
              y1: p.y,
              x2:
                _vm.responsiveSize.diameter / 2 +
                _vm.responsiveSize.diameter / 12,
              y2:
                _vm.responsiveSize.diameter / 2 +
                _vm.responsiveSize.diameter / 12,
              "stroke-width": "1",
              stroke: _vm.strokeColor
            }
          })
        }),
        _vm._v(" "),
        _vm._l(_vm.valuesIndices, function(index) {
          return _c(
            "g",
            { key: index + "_shape_group", staticClass: "shape-group" },
            [
              _c("path", {
                staticClass: "shape",
                staticStyle: { transition: "0.6s" },
                attrs: { d: _vm.points(index), fill: _vm.shapeColors[index] }
              }),
              _vm._v(" "),
              _vm._l(_vm.pointsCaps(index), function(point, key) {
                return _c("circle", {
                  key: key + "_shape_point",
                  staticClass: "shape-point",
                  attrs: {
                    cx: point.x,
                    cy: point.y,
                    r: "2",
                    fill: _vm.shapeColors[index]
                  }
                })
              })
            ],
            2
          )
        })
      ],
      2
    ),
    _vm._v(" "),
    _vm.valuesLabels && _vm.valuesLabels.length > 0
      ? _c(
          "div",
          { staticClass: "labels-group" },
          _vm._l(_vm.labelPoints, function(l, key) {
            return _c(
              "div",
              {
                key: key + "_label",
                staticClass: "label-container",
                style: "top: " + l.y + "px; left: " + l.x + "px;"
              },
              [
                _c("div", {
                  class: ["label", "anchor-" + _vm.valuesLabels[key].anchor],
                  style: "color: " + _vm.labelsColor,
                  domProps: { innerHTML: _vm._s(_vm.valuesLabels[key].name) }
                })
              ]
            )
          })
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-078c9d54", esExports)
  }
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_vertical_line_chart_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a817c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_vertical_line_chart_vue__ = __webpack_require__(31);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_vertical_line_chart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_96a817c0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_vertical_line_chart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/vertical-line-chart/vertical-line-chart.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-96a817c0", Component.options)
  } else {
    hotAPI.reload("data-v-96a817c0", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var VerticalLineChart = /** @class */ (function (_super) {
    __extends(VerticalLineChart, _super);
    function VerticalLineChart() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(VerticalLineChart.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLineChart.prototype, "viewBox", {
        get: function () {
            var w = this.responsiveWidth;
            var h = this.height;
            return '0 0 ' + w + ' ' + h;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLineChart.prototype, "valuesIndices", {
        get: function () {
            return Array.from(new Array(this.values.length), function (v, i) { return i; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VerticalLineChart.prototype, "points", {
        get: function () {
            var _this = this;
            var ps = [];
            for (var i = 0; i < this.values.length; i++) {
                ps.push(this.values[i].map(function (v, i) {
                    var w = _this.responsiveWidth - _this.paddingLeft - _this.paddingRight;
                    var hs = (_this.height - _this.paddingTop - _this.paddingBottom) / (_this.values[0].length - 1);
                    return [Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v, _this.rangeMin, _this.rangeMax, w) + _this.paddingLeft, (hs * i + _this.paddingTop)];
                }));
            }
            return ps;
        },
        enumerable: true,
        configurable: true
    });
    VerticalLineChart.prototype.line = function (index) {
        return 'M' + this.points[index].map(function (xy) { return xy[0] + ' ' + xy[1]; }).join(',');
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "valuesLabelsText", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "valuesLabelsImage", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], VerticalLineChart.prototype, "rangeLabels", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 0 })
    ], VerticalLineChart.prototype, "rangeMin", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 100 })
    ], VerticalLineChart.prototype, "rangeMax", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 700 })
    ], VerticalLineChart.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 400 })
    ], VerticalLineChart.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], VerticalLineChart.prototype, "paddingTop", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], VerticalLineChart.prototype, "paddingRight", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], VerticalLineChart.prototype, "paddingBottom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 80 })
    ], VerticalLineChart.prototype, "paddingLeft", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], VerticalLineChart.prototype, "axisColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: function () { return ['coral']; } })
    ], VerticalLineChart.prototype, "valuesColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(150,150,150)' })
    ], VerticalLineChart.prototype, "rangeLabelsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(50,50,50)' })
    ], VerticalLineChart.prototype, "valuesLabelsColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 11 })
    ], VerticalLineChart.prototype, "rangeLabelsSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 16 })
    ], VerticalLineChart.prototype, "valuesLabelsTextSize", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 18 })
    ], VerticalLineChart.prototype, "valuesLabelsImageSize", void 0);
    VerticalLineChart = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], VerticalLineChart);
    return VerticalLineChart;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (VerticalLineChart);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vertical-line-chart" }, [
    _c(
      "svg",
      {
        attrs: {
          version: "1.1",
          width: _vm.responsiveWidth,
          height: _vm.height,
          viewBox: _vm.viewBox
        }
      },
      [
        _c(
          "g",
          { staticClass: "axis" },
          _vm._l(_vm.values[0], function(v, key) {
            return _c("line", {
              key: key + "_axis",
              attrs: {
                stroke: _vm.axisColor,
                "stroke-width": "1",
                "stroke-linecap": "round",
                x1: _vm.paddingLeft,
                y1:
                  _vm.paddingTop +
                  key *
                    ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                      (_vm.values[0].length - 1)),
                x2: _vm.responsiveWidth - _vm.paddingRight,
                y2:
                  _vm.paddingTop +
                  key *
                    ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                      (_vm.values[0].length - 1))
              }
            })
          })
        ),
        _vm._v(" "),
        _vm._l(_vm.valuesLabelsText, function(v, key) {
          return _vm.valuesLabelsText
            ? _c(
                "g",
                {
                  key: key + "_value_label",
                  staticClass: "value-label",
                  attrs: {
                    transform:
                      "translate(0, " +
                      (_vm.paddingTop +
                        key *
                          ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                            (_vm.values[0].length - 1))) +
                      ")"
                  }
                },
                [
                  _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.paddingLeft - 24,
                        y: "0",
                        dy: "4",
                        "font-size": _vm.valuesLabelsTextSize,
                        "text-anchor": "end",
                        fill: _vm.valuesLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " + _vm._s(v) + "\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.valuesLabelsImage, function(v, key) {
          return _vm.valuesLabelsImage
            ? _c(
                "g",
                {
                  key: key + "_value_label",
                  staticClass: "value-label",
                  attrs: {
                    transform:
                      "translate(0, " +
                      (_vm.paddingTop +
                        key *
                          ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                            (_vm.values[0].length - 1))) +
                      ")"
                  }
                },
                [
                  _c("circle", {
                    attrs: {
                      cx: _vm.paddingLeft - _vm.valuesLabelsImageSize - 18,
                      cy: "0",
                      r: _vm.valuesLabelsImageSize,
                      fill: "grey"
                    }
                  })
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.values[0], function(v, key) {
          return _vm.rangeLabels
            ? _c(
                "g",
                {
                  key: key + "_range_label",
                  staticClass: "range-label",
                  attrs: {
                    transform:
                      "translate(0, " +
                      (_vm.paddingTop +
                        key *
                          ((_vm.height - _vm.paddingTop - _vm.paddingBottom) /
                            (_vm.values[0].length - 1))) +
                      ")"
                  }
                },
                [
                  _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.paddingLeft,
                        y: "0",
                        dy: "14",
                        "font-size": _vm.rangeLabelsSize,
                        "text-anchor": "start",
                        fill: _vm.rangeLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.rangeLabels[0]) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "text",
                    {
                      attrs: {
                        x: _vm.responsiveWidth - _vm.paddingRight,
                        y: "0",
                        dy: "14",
                        "font-size": _vm.rangeLabelsSize,
                        "text-anchor": "end",
                        fill: _vm.rangeLabelsColor
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.rangeLabels[1]) +
                          "\n            "
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        }),
        _vm._v(" "),
        _vm._l(_vm.valuesIndices, function(index) {
          return _c(
            "g",
            { key: index + "_value_group", staticClass: "value-group" },
            [
              _c("path", {
                attrs: {
                  d: _vm.line(index),
                  stroke: _vm.valuesColor[index],
                  "stroke-width": "2",
                  "stroke-linecap": "round",
                  "stroke-dasharray": "1, 4",
                  fill: "transparent"
                }
              }),
              _vm._v(" "),
              _vm._l(_vm.points[index], function(v, key) {
                return _c("circle", {
                  key: key + "_rhombus",
                  attrs: {
                    cx: v[0],
                    cy: v[1],
                    r: "3",
                    fill: _vm.valuesColor[index]
                  }
                })
              })
            ],
            2
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-96a817c0", esExports)
  }
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_scatter_plot_vue__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1161c2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_scatter_plot_vue__ = __webpack_require__(34);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_bustCache_scatter_plot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1161c2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_bustCache_scatter_plot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/scatter-plot/scatter-plot.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {  return key !== "default" && key.substr(0, 2) !== "__"})) {  console.error("named exports are not supported in *.vue files.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1161c2a6", Component.options)
  } else {
    hotAPI.reload("data-v-1161c2a6", Component.options)
' + '  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ScatterPlot = /** @class */ (function (_super) {
    __extends(ScatterPlot, _super);
    function ScatterPlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ScatterPlot.prototype, "responsiveWidth", {
        get: function () {
            if (this.width < window.innerWidth) {
                return this.width;
            }
            else {
                return window.innerWidth;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScatterPlot.prototype, "dataBox", {
        get: function () {
            return {
                xMin: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["b" /* safeMin */])(this.values.map(function (v) { return v.x; })),
                xMax: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["a" /* safeMax */])(this.values.map(function (v) { return v.x; })),
                yMin: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["b" /* safeMin */])(this.values.map(function (v) { return v.y; })),
                yMax: Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["a" /* safeMax */])(this.values.map(function (v) { return v.y; }))
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScatterPlot.prototype, "viewBox", {
        get: function () {
            return '0 0 ' + this.responsiveWidth + ' ' + this.height;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScatterPlot.prototype, "points", {
        get: function () {
            var _this = this;
            var p = this.padding + (this.markerWidth / 2);
            return this.values.map(function (v) { return [
                Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v.x, _this.dataBox.xMin, _this.dataBox.xMax, _this.responsiveWidth - p * 2) + p,
                _this.height - Object(__WEBPACK_IMPORTED_MODULE_1__utils_viewport_utils__["d" /* scaleValue */])(v.y, _this.dataBox.yMin, _this.dataBox.yMax, _this.height - p * 2) - p
            ]; });
        },
        enumerable: true,
        configurable: true
    });
    ScatterPlot.prototype.markerFill = function (index) {
        var v = this.values[index];
        if (v.markerUrl) {
            return "url(#image" + index + ")";
        }
        else {
            return this.markerBgColor;
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], ScatterPlot.prototype, "values", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'rgb(200,200,200)' })
    ], ScatterPlot.prototype, "markerStrokeColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 1 })
    ], ScatterPlot.prototype, "markerStrokeWidth", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 50 })
    ], ScatterPlot.prototype, "markerWidth", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'grey' })
    ], ScatterPlot.prototype, "markerBgColor", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 500 })
    ], ScatterPlot.prototype, "width", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 300 })
    ], ScatterPlot.prototype, "height", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 20 })
    ], ScatterPlot.prototype, "padding", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: 'transparent' })
    ], ScatterPlot.prototype, "bgColor", void 0);
    ScatterPlot = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], ScatterPlot);
    return ScatterPlot;
}(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Vue"]));
/* harmony default export */ __webpack_exports__["a"] = (ScatterPlot);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scatter-plot" }, [
    _c(
      "svg",
      {
        style: "background-color: " + _vm.bgColor,
        attrs: {
          version: "1.1",
          width: _vm.responsiveWidth,
          height: _vm.height,
          viewBox: _vm.viewBox
        }
      },
      [
        _c(
          "defs",
          _vm._l(_vm.values, function(v, key) {
            return v.markerUrl
              ? _c(
                  "pattern",
                  {
                    key: "image" + key,
                    attrs: {
                      id: "image" + key,
                      height: "1",
                      width: "1",
                      x: "0",
                      y: "0",
                      patternContentUnits: "objectBoundingBox"
                    }
                  },
                  [
                    _c("image", {
                      attrs: {
                        x: "0",
                        y: "0",
                        height: "1",
                        width: "1",
                        "xlink:href": v.markerUrl
                      }
                    })
                  ]
                )
              : _vm._e()
          })
        ),
        _vm._v(" "),
        _vm._l(_vm.points, function(p, key) {
          return _c("image", {
            key: "circle" + key,
            class: _vm.values[key].class,
            attrs: {
              "xlink:href": _vm.values[key].markerUrl,
              height: _vm.markerWidth,
              width: _vm.markerWidth,
              x: p[0] - _vm.markerWidth / 2,
              y: p[1] - _vm.markerWidth / 2
            }
          })
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1161c2a6", esExports)
  }
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=pack.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/wok-charts/dist/pack.js
// module id = 64
// module chunks = 0